import featureCalendar from '../assets/feature-calendar.jpg';
import featureWeather from '../assets/feature-weather.jpg';
import featureKids from '../assets/feature-kids.jpg';
import featurePhotos from '../assets/feature-photos.jpg';

function FeaturesPage() {
  return (
    <div className="py-12 bg-slate-50">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 glow-text">Family Dashboard Features</h1>
        
        {/* Calendar Feature */}
        <div className="flex flex-col md:flex-row items-center bg-white rounded-xl shadow-lg overflow-hidden mb-12">
          <div className="md:w-1/2">
            <img src={featureCalendar} alt="Calendar feature" className="w-full h-auto" />
          </div>
          <div className="md:w-1/2 p-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--ryken-accent)' }}>Calendar Integration</h2>
            <p className="mb-4">
              Stay on top of your family's schedule with our intuitive calendar display. Family Dashboard connects to Google Calendar to show everyone's events in one place.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Color-coded events for different family members</li>
              <li>Week-at-a-glance view</li>
              <li>Daily agenda display</li>
              <li>Multiple calendar support</li>
              <li>Auto-refreshing to always stay current</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              * Requires Google Calendar access with your permission
            </p>
          </div>
        </div>
        
        {/* Weather Feature */}
        <div className="flex flex-col md:flex-row-reverse items-center bg-white rounded-lg shadow-lg overflow-hidden mb-12">
          <div className="md:w-1/2">
            <img src={featureWeather} alt="Weather feature" className="w-full h-auto" />
          </div>
          <div className="md:w-1/2 p-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--ryken-accent)' }}>Weather & Time</h2>
            <p className="mb-4">
              Always know what to expect with current weather conditions and forecasts for your location.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Current temperature and conditions</li>
              <li>5-day forecast with high/low temperatures</li>
              <li>Customizable location settings</li>
              <li>Choice of temperature units (°F or °C)</li>
              <li>Current time and date display</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              * Weather data provided by Open-Meteo API
            </p>
          </div>
        </div>
        
        {/* Kids Activities Feature */}
        <div className="flex flex-col md:flex-row items-center bg-white rounded-xl shadow-lg overflow-hidden mb-12">
          <div className="md:w-1/2">
            <img src={featureKids} alt="Kids activities feature" className="w-full h-auto" />
          </div>
          <div className="md:w-1/2 p-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--ryken-accent)' }}>Kids Activities & Learning</h2>
            <p className="mb-4">
              Make learning fun with daily educational content designed for children.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Daily reading practice with age-appropriate sentences</li>
              <li>Math problems that automatically adapt to each child's skill level</li>
              <li>Daily mystery image reveal (Wikimedia Picture of the Day)</li>
              <li>Word of the day with pronunciation and definition</li>
              <li>A daily Question of the Day to spark family conversation</li>
              <li>Separate profiles for each child, each tracking their own progress</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              * Content refreshes daily to keep children engaged
            </p>
          </div>
        </div>
        
        {/* Photos Feature */}
        <div className="flex flex-col md:flex-row-reverse items-center bg-white rounded-lg shadow-lg overflow-hidden mb-12">
          <div className="md:w-1/2">
            <img src={featurePhotos} alt="Photos feature" className="w-full h-auto" />
          </div>
          <div className="md:w-1/2 p-8">
            <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--ryken-accent)' }}>Photo Display</h2>
            <p className="mb-4">
              Turn your dashboard into a digital photo frame showing your favorite family memories.
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Send photos straight from your phone by scanning a QR code</li>
              <li>Or display photos from a local folder on the device</li>
              <li>Automatic slideshow of your chosen photos</li>
              <li>No Google account or cloud service required</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              * Photos stay on your device — nothing is uploaded to us
            </p>
          </div>
        </div>
        
        {/* Technical Specs */}
        <div className="bg-blue-900 text-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--ryken-accent)' }}>Technical Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-xl font-semibold mb-2">Supported Platforms</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Raspberry Pi (recommended for dedicated display)</li>
                <li>Windows</li>
                <li>macOS</li>
                <li>Linux</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">Requirements</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Internet connection</li>
                <li>Google account (optional — only for the calendar feature)</li>
                <li>Display monitor</li>
                <li>500MB free storage space</li>
              </ul>
            </div>
          </div>
          <p className="mt-6 text-sm text-blue-100">
            Set-and-forget: Family Dashboard updates itself automatically in the background, and on a Raspberry Pi it starts on boot for an always-on display.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FeaturesPage;